<template>
  <div class="main-body">
    <!-- ヘッダー -->
    <div class="header-box">
      <div class="header-menu">
        <p><b style="font-size:28px; font-weight: 800;">Calendar</b></p>
        <div style="margin-left: 25px; font-size:16px; color: #666;">
          <p style="text-align: left;">予定調整・カレンダー画面</p>
          <div style="display: flex;">
            <p style="padding-left: 3px; font-size: 12px;">{{getRenkei()}}</p>
            <a @click="openSettings()" style="padding-left: 3px; font-size: 12px; margin-left: 8px;"
              v-if="getRenkei() != messageSuperUser">設定を開く</a>
          </div>
        </div>
      </div>
      <div class="header-menu">
        <button class="button is-primary" @click="createRecommendEvent()"><span class="mdi mdi-plus" style="margin-right: 4px;"></span>予定の追加</button>
      </div>
    </div>

    <div class="calendar-view-wrapper disp-scroll">
      <OverlayLoading
        :absoluteFlg="true"
        v-if="isFilterLoading || isScheduleLoading"/>
      <FullCalendar
        class="calendar-view"
        ref="fullCalendar"
        :locale="locale"
        :defaultView="defaultView"
        :eventRender="eventRender"
        :header="header"
        :plugins="calendarPlugins"
        :slotDuration="'00:15:00'"
        :slotLabelInterval="'01:00'"
        :selectable="true"
        :buttonText="buttonText"
        :weekends="calendarWeekends"
        :events="schedulesFilter"
        :views="views"
        @eventPositioned="eventPositioned"
        @select="select"
        @eventClick="eventClick"
        @datesRender="changeSchedules"
        :eventResizableFromStart="true"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import FullCalendar from "@fullcalendar/vue"
import dayGridPlugin from "@fullcalendar/daygrid"
import timeGridPlugin from "@fullcalendar/timegrid"
import interactionPlugin from "@fullcalendar/interaction"
import listPlugin from '@fullcalendar/list'
import jaLocale from "@fullcalendar/core/locales/ja"
import OverlayLoading from '@/components/animations/OverlayLoading'

export default {
  components: {
    FullCalendar,
    OverlayLoading,
  },
  props: {
    authType: {
      type: String,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    schedules: {
      type: Array,
      required: true
    },
    calendarSettings: {
      type: Array,
      required: true
    },
    eventGroup: {
      type: Array,
      required: true
    },
    isSelfCheck: {
      type: Boolean,
      required: true
    },
    isScheduleLoading: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      selectDate: 'today',
      selected: {},
      calendar: null,
      viewType: '週',
      nowTime: null,
      clientid: null,
      subdomain: null,
      locale: jaLocale,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay'
      },
      defaultView: 'timeGridWeek',
      calendarWeekends: true,
      calendarPlugins: [
        dayGridPlugin,
        timeGridPlugin,
        interactionPlugin,
      ],
      buttonText: {
        today: '今日',
        dayGridWeek: '予定リスト'
      },
      fileSelected: null,
      isOpenFileList: false,
      views: {
        dayGridCustomDay: {
          type: 'dayGrid',
          duration: { days: 3 },
          buttonText: '予定リスト'
        }
      },
      isFilterLoading: false,
      messageSuperUser: 'スーパーユーザー（他社アカウントにいるため予定作成などしないでください）'
    }
  },
  computed: {
    schedulesFilter () {
      let schedulesFilter = []
      this.isFilterLoading = true
      for (const s of this.schedules) {
        // 自分の予定か
        if (s.editable && this.isSelfCheck) {
          schedulesFilter.push(s)
        } else {
          for (const c of this.calendarSettings) {
            if (s.className === 'class-' + c.calendar_user && c.is_check) {
              schedulesFilter.push(s)
              break
            }
          }
        }
      }
      this.isFilterLoading = false
      return schedulesFilter
    }
  },
  methods: {
    changeSchedules (e) {
      this.$emit('changeSchedules', e.view.currentStart)
    },
    getRenkei () {
      // スーパーユーザーの場合は他社のアカウント連携状況が見れるように表示しておく
      if (this.user.isAgent && this.user.companyID != '32217bf93d824aec3888413722f41a91') {
        return this.messageSuperUser
      } else if (this.authType === 'google') {
        return 'Googleカレンダーと連携済'
      } else if (this.authType === 'cybozu') {
        return 'サイボウズオフィスと連携済'
      } else if (this.authType === 'garoon') {
        return 'ガルーンと連携済'
      } else if (this.authType === 'msoffice') {
        return 'Office365と連携済'
      } else if (this.authType === 'gsession') {
        return 'Group Sessionと連携済'
      } else if (this.authType === 'lineworks') {
        return 'LINE WORKSと連携済'
      } else if (this.authType === 'nolinkage') {
        return '連携なしで利用中'
      }
    },
    openSettings () {
      this.$emit('openSettings')
    },
    eventPositioned (info) {
      if (info.view.viewSpec.type === 'listWeek') {
        let els = document.querySelectorAll('td.fc-widget-header')
        for (let e of els) {
          e.colSpan = '4'
        }
      }
    },
    eventRender (info) {
      let fileRef = null
      for (const e of this.eventGroup) {
        if (e.calendar_id === info.event.id) fileRef = e
      }
      let memberList = ''
      let declinedNum = 0
      let acceptedNum = 0
      let tentativeNum = 0
      let needsActionNum = 0
      if (info.event.extendedProps.calendarType === 'google') {
        for (const ats of info.event.extendedProps.attendees) {
          memberList += ats.email + ' '
          switch (ats.responseStatus) {
            case 'accepted':
              acceptedNum++
              break
            case 'tentative':
              tentativeNum++
              break
            case 'needsAction':
              needsActionNum++
              break
            case 'declined':
              declinedNum++
              break
          }
        }
      }
      let tag  =  null
      if (fileRef) {
        if (info.view.viewSpec.type === 'listWeek') {
          tag ='<div style="padding-left: 12px; width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; min-height: 24px;"><span class="mdi mdi-file-document" style="margin-right: 4px;"></span>添付ファイルあり</div>'
        } else {
          tag ='<div style="width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; min-height: 24px;"><span class="mdi mdi-file-document" style="margin-right: 4px;"></span>添付ファイルあり</div>'
        }
      } else {
        if (info.view.viewSpec.type === 'listWeek') {
          tag = '<div style="padding-left: 12px; width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; min-height: 24px;"><span class="mdi mdi-border-none-variant" style="margin-right: 4px;"></span>添付ファイルなし</div>'
        } else {
          tag = '<div style="width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; min-height: 24px;"><span class="mdi mdi-border-none-variant" style="margin-right: 4px;"></span>添付ファイルなし</div>'
        }
      }
      if (memberList != '') {
        if (info.view.viewSpec.type === 'listWeek') {
          tag +='<div style="padding-left: 12px; width: 100%; white-space: pre-wrap; height: 150px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"><span class="mdi mdi-account-box-multiple" style="margin-right: 4px;"></span>参加者  <span class="mdi mdi-calendar-multiple-check" style="margin-right: 4px;"></span>' + acceptedNum + ' <span class="mdi mdi-calendar-question" style="margin-right: 4px;"></span>' + tentativeNum + ' <span class="mdi mdi-calendar-remove" style="margin-right: 4px;"></span>' + declinedNum + ' <span class="mdi mdi-flag-variant-outline" style="margin-right: 4px;"></span>' + needsActionNum + '<br>' + memberList + '</div>'
        } else {
          tag +='<div style="width: 100%; white-space: pre-wrap; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"><span class="mdi mdi-account-box-multiple" style="margin-right: 4px;"></span>参加者  <span class="mdi mdi-calendar-multiple-check" style="margin-right: 4px;"></span>' + acceptedNum + ' <span class="mdi mdi-calendar-question" style="margin-right: 4px;"></span>' + tentativeNum + ' <span class="mdi mdi-calendar-remove" style="margin-right: 4px;"></span>' + declinedNum + ' <span class="mdi mdi-flag-variant-outline" style="margin-right: 4px;"></span>' + needsActionNum + '<br>' + memberList + '</div>'
        }
      } else {
        if (info.view.viewSpec.type === 'listWeek') {
          tag +='<div style="padding-left: 12px; width: 100px; white-space: pre-wrap; height: 150px; overflow: hidden;"></div>'
        }
      }
      info.el.insertAdjacentHTML('beforeend', tag)
    },
    eventClick (info) {
      this.$emit('eventClick', info)
    },
    select (info) {
      this.$emit('select', info)
    },
    createRecommendEvent (info) {
      this.$emit('createRecommendEvent', info)
    },
  }
}
</script>

<style lang='scss' scoped>
.main-body {
  height: calc(100vh - 80px);
  width: -webkit-fill-available;
  position: relative;
}
.member {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%; text-align: left; padding-left: 24px;
}
.-pointer {
  cursor: pointer;
}
.member:hover {
  background-color:rgba(240, 200, 200, 0.8);
}
.header-box {
  width: calc(100% - 80px);
  margin: 10px 40px;
  margin-bottom: 10px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
  flex-wrap: wrap;
}
.header-menu {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}
.calendar-view-wrapper {
  max-width: 1800px;
  height: calc(100% - 100px);
  position: relative;
  .calendar-view {
    padding: 24px;
    margin: 0 auto;
    max-width: 900px;
    // height: 100%;
  }
}
.drawer-menu {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 40%;
  min-width: 400px;
  background: #FEFEFE;
  padding: 16px;
  z-index: 201;
}
.drawer-back {
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  z-index: 200; top: 0;
}
.right-enter-active, .right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.right-enter, .right-leave-to {
  transform: translateX(100vw) translateX(0px);
}
.my-calendar {
  display: flex;
  margin: 4px;
  padding-left: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Calendar/DateView.vue